<template>
	<div class="content background1">
		<div class="tableBox11">
			<div class="tableMes">
				<div class="table" style="padding: 0">
					<div class="treeMes" v-if="getTreeMes=='1'">
						<p class="title">{{$t('label_407')}}</p>
						<div class="chooseBox spaceBetween">
							<div class="selectBox">
								<div>
									<div class="selectChoose">
										<div class="selectText" style="width: 70px;">
											<p>{{$t('label_383')}}</p>
										</div>
										<el-select v-model="searchDataList.warehouseId" :placeholder="$t('input_65')" @change="updateTable" clearable>
											<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
											</el-option>
										</el-select>
									</div>
								</div>
								<div>
									<div class="selectChoose" style="width: 400px;">
										<div class="selectText" >
											<p>{{$t('label_664')}}</p>
										</div>
										<div class="select">
											<el-input v-model="searchDataList.name" clearable></el-input>
										</div>
									</div>
								</div>
								<div>
									<div class="selectChoose" style="width: 400px;">
										<div class="selectText" >
											<p>{{$t('label_129')}}</p>
										</div>
										<div class="select">
											<el-input v-model="searchDataList.model" clearable></el-input>
										</div>
									</div>
								</div>
							</div>
							<div class="buttonBox">
								<div>
									<div class="chooseButton sendButton" @click="search"><i class="el-icon-search"></i>{{$t('btn_2')}}</div>
								</div>
							</div>
						</div>
						<div class="spotMes2Box" :style="{'height':'calc(100% - 150px)'}">
<!--							<div class="buttonBox" style="margin-bottom: 10px;">-->
<!--								<div>-->
<!--									<div class="chooseButton searchButton" @click="exportClick" v-if="MenuRoleList.indexOf('7')>=0"><i class="el-icon-download"></i>{{$t('btn_10')}}</div>-->
<!--								</div>-->
<!--							</div>-->
							<div class="tableMin" style="height: calc(100% - 100px);">
								<!-- <el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDataTreeTime" highlight-current-row @current-change="handleCurrentChangeTree"
								 border style="width: 100%;" height="100%" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}"
								 :cell-style="rowstyle" row-key="rowKey" lazy :load="loadChilds" :tree-props="{children: 'children', hasChildren: 'hasChildren'}"> -->
                <el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDataTreeTime" highlight-current-row @current-change="handleCurrentChangeTree"
                 border style="width: 100%;" height="100%" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}"
                 :cell-style="rowstyle" row-key="rowKey">
									<!-- <el-table-column header-align="center" align="center" label="No" type="index" :index="getIndex" width="50">
									</el-table-column> -->
									<el-table-column prop="code" :label="$t('label_124')" align="left">
									</el-table-column>
									<el-table-column prop="name" :label="$t('label_664')" align="left">
									</el-table-column>
									<el-table-column prop="model" :label="$t('label_129')" align="center">
									</el-table-column>
									<el-table-column prop="maker" :label="$t('label_672')" align="left">
										<template slot-scope="scope">
											<popMesBox :popMes="scope.row.maker" :hoverMes="scope.row.maker" :popWidth="200"></popMesBox>
										</template>
									</el-table-column>
									<el-table-column prop="saler" :label="$t('label_235')" align="left">
										<template slot-scope="scope">
											<popMesBox :popMes="scope.row.saler" :hoverMes="scope.row.saler" :popWidth="200"></popMesBox>
										</template>
									</el-table-column>
									<el-table-column prop="stock" :label="$t('label_504')" align="left">
									</el-table-column>
									<el-table-column prop="type" :label="$t('label_410')" align="left">
									</el-table-column>
									<el-table-column prop="typeName" :label="$t('label_243')" align="left">
									</el-table-column>
									<el-table-column prop="warehouseName" :label="$t('label_327')" align="left">
									</el-table-column>
									<el-table-column prop="remark" :label="$t('label_252')" align="left">
										<template slot-scope="scope">
											<popMesBox :popMes="scope.row.remark" :hoverMes="scope.row.remark" :popWidth="200"></popMesBox>
										</template>
									</el-table-column>
								</el-table>
								<div style="position: absolute;bottom: 30px;left: 30%">
									<Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
									 @parentMethod="searchPage"></Page>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--		<exportMes :exportTitle="exportTitle" :exportData="tableDataTreeTimeExport" :exportList="exportList" style="width: 100%;height: 100%"-->
		<!--		 ref="exportBox"></exportMes>-->
	</div>
</template>

<script>
	import "@/assets/css/map/map.css"
	import "@/assets/css/common/spot.css"
	import Page from "@/components/common/page";
	import TimePage from "@/assets/js/timePage/timePage.js";
	import utils from '@/utils/utils'
	import calendar from "@/components/list/calendar/calendar";
	import file from "@/assets/js/file/file.js";
	import exportMes from "@/components/list/export/export";
	import popMesBox from "@/components/list/popover/pop";

	export default {
		name: 'stock',
		components: {
			Page,
			calendar,
			exportMes,
			popMesBox,
		},
		data() {
			return {
				name: '',
				Warehouseid: '',
				Affiliatedunit: '', //所属单位
				bname: '', // 备件名称
				model: '', //  备件型号
				pageNum: 1,
				select: 0,
				pageSize: 10,
				pageCount: 0,
				Readytime: '',
				height: 620,
				MenuRoleList: [],
				exportTitle: this.$t('label_396'),
				tableDataTreeInfo: {},
				factoryDialogTitle: this.$t('btn_14'),
				getTreeMes: '1',
				dialogFactory: false,
				searchDataList: {
					warehouseId: 0,
					name: '',
					model: ''
				},
				tableDataTreeTime: [],
				tableDataTreeTimeExport: [],
				tableDataTree: [],
				factoryTypeList: [],
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				ckid: '',
				options: [], // 下拉数组
				dateTime: '', // 当前时间
				linshi: [{
					name: 'cechi',
					id: '0',
					num: '20',
				}, {
					name: 'ceshi1',
					id: '1',
					num: '30'
				}, {
					name: 'ceshi2',
					id: '2',
					num: '40'
				}]
			}
		},
		methods: {
			loadChilds(tree, treeNode, resolve) {
				file.getstockDetailpage({'code' : tree.id, 'warehouseId' : tree.warehouseId}).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						resolve(data.data);
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			// 类型id
			updateTable(value) {
				this.ckid = value
			},
			// 获取当前时间
			getNowTimes: function() {
				let dateTime
				let yy = new Date().getFullYear()
				let mm = new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) : new Date().getMonth() + 1
				let dd = new Date().getDate()
				let hh = new Date().getHours()
				let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes()
				let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds()
				this.dateTime = yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss
				return dateTime
			},
			rowstyle({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if(row['hasChildren']){//总量
					if (columnIndex == 5) {//库存数量
						let sn = row.stockNum;
						row['stock'] = this.$t('label_416') + ':' + sn + row.unit + '\n' + this.$t('label_413') + ':' + row.warningInventory + row.unit;
						if(sn <= row.warningInventory){//判断库存数量
							return 'color: red;';//修改的样式
						}
					}
				}else{//明细
					if (columnIndex == 5) {//库存数量
						row['stock'] = this.$t('label_416') + ':' + row.stockNum + row.unit;
					}
				}
				if (columnIndex == 6) {//在库时长
					var new_date = new Date(); //新建一个日期对象，默认现在的时间
					var old_date = new Date(row.recordTime); //设置过去的一个时间点，"yyyy-MM-dd HH:mm:ss"格式化日期
					var difftime = (new_date - old_date) / 1000; //计算时间差,并把毫秒转换成秒
					var newtime = parseInt(difftime / 3600);
					row['type'] = this.$t('label_416') + ':' + newtime + this.$t('label_534') + '\n' + this.$t('label_413') + ':' + row.warningTime + this.$t('label_534')
					if (newtime >= row.warningTime) { //  判断一下 在库时长  库存数量
						return 'color: red;' //修改的样式
					}
				}
			},
			// 点击查询
			selectlist(param) {
				// let param = {
				//   warehouseId:this.ckid,
				//   name: this.searchDataList.name,
				//   model:this.searchDataList.model,
				//   pageNum: 1,
				//   pageSize: this.pageSize
				// }
				file.getstockpage(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableDataTreeTime = data.data.records // table数据
						this.pageCount = data.data.total;
						this.pageSize = data.data.size;
						this.pageNum = data.data.current;
						this.$refs['pageModel'].setCurrent(this.pageNum);
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			// 仓库下拉选
			getWarehousedown() {
				file.getWarehousedown().then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.options = data.data;
						this.options.unshift({
							id: 0,
							name: this.$t('label_272')
						})
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			searchPage(param) {
				var dataParam = this.searchDataList; // 搜索条件
				var newParam = Object.assign(param, dataParam);
				this.pageNum = newParam.pageNum;
				this.pageSize = newParam.pageSize;
				this.selectlist(newParam);
			},
			getIndex(index) {
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			exportClick() {
				this.$refs.exportBox.setExportExcel();
			},
			selectProp: function(index) {
				console.log(index)
				this.select = index
			},
			handler() {

			},
			handleCurrentChangeTree(info) {
				this.tableDataTreeInfo = info;
			},
			handleCurrentChangeTreeTime(info) {},
			search() {
				let param = {
					pageNum: 1,
					pageSize: this.pageSize
				}
				this.searchPage(param);
			},
		},
		created() {
			this.getNowTimes() // 获取当前时间
			this.getWarehousedown();
			this.search();
		}

	}
</script>

<style scoped>
	.el-input {
		width: 200px;
	}

	/deep/.el-table .cell {
		white-space: pre-line;
	}
</style>



// WEBPACK FOOTER //
// src/pages/part/stock.vue